import React, { forwardRef, useImperativeHandle } from 'react'
import { Paragraph, Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter, useOverlay } from '@fs/zion-ui'
import { i18n } from '@fs/zion-locale'

export default forwardRef(function VolumeSetSearchOverlay(
  { description, onPreferenceSet, question, title },
  forwardedRef
) {
  const overlay = useOverlay()
  useImperativeHandle(forwardedRef, () => overlay)

  async function setPreference(preferVolumeSetSearch) {
    overlay.close()
    onPreferenceSet(preferVolumeSetSearch)
  }

  return (
    <DialogOverlay {...overlay} title={title}>
      {question}
      <Paragraph size="sm">{description}</Paragraph>

      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button emphasis="high" onClick={() => setPreference(true)}>
            {i18n.t('common-ui:yes.action')}
          </Button>
          <Button onClick={() => setPreference(false)}>{i18n.t('common-ui:no.action')}</Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
})
